/**
 * The counts offered as one-tap presets, shared by the trace dialog and the
 * colour-count control on existing artwork.
 *
 * Its own module so the panel does not pull the whole tracer — and the tracer's
 * heavy dependencies — into the startup bundle just to render eight buttons.
 */
export const COLOUR_TRACE_PRESETS = [10, 7, 6, 5, 4, 3, 2, 1] as const;
